import React from 'react';
import { Link } from 'react-router-dom';
import { Tooltip } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import Utils from '../../../../utilities/utils';
import { ActionButton } from '../../../../components/ActionButton/ActionButton';
import StyledGridRow from '../../../../components/Basic/StyledGridRow/StyledGridRow';
import StyledGridCell from '../../../../components/Basic/StyledGridCell/StyledGridCell';
import { useShiftListRowStyles } from './ShiftListRow.css';
import StyledActionContainer from '../../../../components/Basic/StyledActionContainer/StyledActionContainer';
import Can from '../../../../components/Common/Can';
import { useIntl } from 'react-intl';

function makeLinesListForDisplay(lines, lineIds, isPreview) {
  if (!lines || !lineIds || !(lineIds.length > 0)) {
    return '';
  }
  let returnLines = '';
  let counter = 0;

  lineIds.forEach((lineElementId) => {
    let result;
    let resultDesc;
    if (!isPreview) {
      result = lines.filter(line => line.id === lineElementId);
      if (result.length > 0) {
        counter++;
        resultDesc = (result[0].title != null ? result[0].title : '');
        returnLines += resultDesc;
        if (counter < lineIds.length && resultDesc.length > 0) {
          returnLines += ', ';
        }
      }
    } else {
      result = lines.filter(line => line.value === lineElementId);
      if (result.length > 0) {
        counter++;
        resultDesc = (result[0].text != null ? result[0].text : '');
        returnLines += resultDesc;
        if (counter < lineIds.length && resultDesc.length > 0) {
          returnLines += ', ';
        }
      }
    }
  });
  return returnLines;
}

function getAvatar(shiftType) {
  if (shiftType === 1 || shiftType === "1") {
    return 'data:image/png;base64,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';
  }
  return 'data:image/png;base64,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';
}

interface IShiftListRow {
  isPreview: boolean;
  shift: any;
  shiftType: string;
  repeatId?: string;
  count: number;
  endDate: string;
  lines: any;
  timezone: string;
  gridBreak: any;
  actionButtonHidden: boolean;
  onDeleteShift?: (shift: any) => void;
}

const ShiftListRow = ({
  isPreview,
  shift,
  shiftType,
  repeatId,
  count,
  endDate,
  lines,
  timezone,
  gridBreak,
  actionButtonHidden,
  onDeleteShift }: IShiftListRow) => {
  const intl = useIntl();
  const classes = useShiftListRowStyles();

  return <>
    <StyledGridRow>
      <StyledGridCell {...gridBreak.shifts}>
        <div className={classes.productTitleContainer}>
          <div className={classes.imageHolder}>
            {
              <img
                src={getAvatar(shiftType)}
                className="product-image" alt=""
              />
            }
          </div>
          <div className="productTitle">
            <div><strong>{shift.title}</strong></div>
            <div><em>{shift.description}</em></div>
          </div>
        </div>
      </StyledGridCell>
      <StyledGridCell {...gridBreak.repeats} >
        <div><strong>{Utils.makeDatesBYDAYForDisplay(shift.recurrenceRule, intl)}</strong></div>
        <div>{Utils.makeDatesFREQForDisplayRow(shift.recurrenceRule, intl)}</div>
      </StyledGridCell>

      <StyledGridCell {...gridBreak.time} >
        <div>
          <strong>
            {Utils.timeToFormat(shift.startTime, timezone)}
-
            {Utils.timeToFormat(shift.endTime, timezone)}
          </strong>
        </div>
      </StyledGridCell>

      <StyledGridCell {...gridBreak.ends} >
        {Utils.getFREQRepeat(repeatId, count, endDate, intl)}
      </StyledGridCell>
      <StyledGridCell {...gridBreak.lines} >
        {makeLinesListForDisplay(lines, shift.lineIds, isPreview)}
      </StyledGridCell>
      {!actionButtonHidden && <StyledGridCell {...gridBreak.actionButtons} >
        <Can do="edit" on="schedule">
          <StyledActionContainer breaks={{ md: true }}>
            <Link to={`/site/${shift.siteId}/setup/shift/${shift.id}/edit/${shift.typeId}`}
            >
              <Tooltip title={intl.formatMessage({ id: 'detail_Edit' })}>
                <ActionButton>
                  <EditIcon />
                </ActionButton>
              </Tooltip>
            </Link>
            <Link to={`/site/${shift.siteId}/setup/shift/${shift.id}/clone/${shift.typeId}`}
            >
              <Tooltip title={intl.formatMessage({ id: 'detail_Clone' })}>
                <ActionButton>
                  <FileCopyIcon />
                </ActionButton>
              </Tooltip>
            </Link>

            <Tooltip title={intl.formatMessage({ id: 'detail_Delete' })}>
              <ActionButton
                onClick={() => onDeleteShift && onDeleteShift(shift)}>
                <DeleteIcon />
              </ActionButton>
            </Tooltip>
          </StyledActionContainer>
        </Can>

      </StyledGridCell>
      }

    </StyledGridRow>
  </>
};

export default ShiftListRow;
